export default __webpack_public_path__ + "static/media/expl-dissect_09_EN.03b18e56.png";